import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10ZM10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM8.91603 6.37596C8.68588 6.22253 8.38997 6.20823 8.14611 6.33874C7.90224 6.46926 7.75 6.7234 7.75 7V13C7.75 13.2766 7.90224 13.5307 8.14611 13.6613C8.38997 13.7918 8.68588 13.7775 8.91603 13.624L13.416 10.624C13.6247 10.4849 13.75 10.2508 13.75 10C13.75 9.74924 13.6247 9.51506 13.416 9.37596L8.91603 6.37596ZM11.6479 10L9.25 11.5986V8.40139L11.6479 10Z",
  fill: "#2491E7"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }